import styles from "./Permissions.module.css";
import { PermissionsUser } from "@/components/modals/UserPanel/PermissionsUser";
import { Popup } from "./Popup";
import { TypeUser } from "./TypeUser";
import { ActiveUser } from "./ActiveUser";
import { Fio } from "./Fio";
import { Password } from "./Password";
import { userStore } from "@/stores/UserStore";
import { User } from "@/types/User.interface";
export const Permissions = () => {
  return (
    <>
      <div className={styles.section}>
        <span>Данные учетной записи</span>
        <TypeUser />
        <ActiveUser />
        <Fio />
        <Password />
      </div>

      <PermissionsUser user={userStore as User} />
      <Popup />
    </>
  );
};
